import React, { ReactNode } from 'react';
import { Button, Typography } from '@mui/material';

import { default as DeleteIcon } from '@mui/icons-material/DeleteOutlineOutlined';
import { default as EditIcon } from '@mui/icons-material/Edit';
import { generateDataTestId } from 'src/utils';
import { normalizeLevelLabel } from '../edit/control/LevelsAndRooms/component/Level';
import { Room as RoomType } from '../../system/rooms';

interface EditDeleteButtonsProps {
  editCallback: () => void;
  deleteCallback: () => void;
  otherCallback?: () => void;
  hideEdit?: boolean;
  hideDelete?: boolean;
  // other handles any third use-case-specific buttons
  hideOther?: boolean;
  otherText?: string;
  otherIcon?: ReactNode;
  dataProps?: RoomType;
}

const EditDeleteButtons: React.FC<{ props: EditDeleteButtonsProps }> = ({
  props,
}) => {
  const {
    hideEdit,
    hideDelete,
    hideOther,
    otherText,
    otherIcon,
    editCallback,
    deleteCallback,
    otherCallback,
    dataProps,
  } = props;

  return (
    <>
      {!hideEdit && (
        <Button
          onClick={editCallback}
          data-testid={generateDataTestId(
            `${normalizeLevelLabel(dataProps?.ROOM_LEVEL || '')}-${dataProps?.ROOM_TYPE}`,
            undefined,
            'editButton',
          )}
          size="small"
          startIcon={<EditIcon sx={{ color: 'secondary.main' }} />}
          sx={{
            color: 'primary.main',
            textTransform: 'capitalize',
            '&:hover': {
              backgroundColor: 'grey.50',
            },
          }}
        >
          <Typography
            sx={{
              color: 'secondary.main',
              fontSize: '14px',
              fontWeight: '500',
            }}
          >
            Edit
          </Typography>
        </Button>
      )}
      {!hideOther && (
        <Button
          onClick={otherCallback}
          data-testid={generateDataTestId(
            `${normalizeLevelLabel(dataProps?.ROOM_LEVEL || '')}-${dataProps?.ROOM_TYPE}`,
            undefined,
            'otherButton',
          )}
          size="small"
          startIcon={otherIcon}
          sx={{ color: 'primary.main', textTransform: 'capitalize' }}
        >
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: '500',
            }}
          >
            {otherText}
          </Typography>
        </Button>
      )}
      {!hideDelete && (
        <Button
          onClick={deleteCallback}
          data-testid={generateDataTestId(
            `${normalizeLevelLabel(dataProps?.ROOM_LEVEL || '')}-${dataProps?.ROOM_TYPE}`,
            undefined,
            'deleteButton',
          )}
          size="small"
          startIcon={<DeleteIcon />}
          sx={{ color: 'error.main', textTransform: 'capitalize' }}
        >
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: '500',
            }}
          >
            Delete
          </Typography>
        </Button>
      )}
    </>
  );
};

export default React.memo(EditDeleteButtons);
